import { render, staticRenderFns } from "./wikiGeet.vue?vue&type=template&id=2b9fd55e"
import script from "./wikiGeet.vue?vue&type=script&lang=js"
export * from "./wikiGeet.vue?vue&type=script&lang=js"
import style0 from "./wikiGeet.vue?vue&type=style&index=0&id=2b9fd55e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports